import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { RouteObject } from "react-router-dom";

import { ErrorPage } from "@/common/components/error-page/error-page";
import { Failed } from "@/common/components/info/info";
import { Mode } from "@/domain/plan/reports/reports.flow";

import * as Report from "./report/report";
import { path as reportsPath, Reports, ReportsParams } from "./reports/reports";
import {
  Params,
  Restoration,
} from "./shared/components/postal-code-dialog/postal-code-restoration";
import {
  path as stockExchangePath,
  StockExchange,
  StockExchangeParams,
} from "./stock-exchange/stock-exchange";
import {
  path as yieldPredictionsPath,
  YieldPredictions,
} from "./yield-predictions/yield-predictions";

const getReportsRoutes = (mode: Mode): RouteObject[] => [
  {
    children: [
      {
        element: (
          <ErrorBoundary
            fallbackRender={({ error }) => <Failed error={error} />}
          >
            <Suspense fallback={<Report.Skeleton />}>
              <Report.Report mode={mode} />
            </Suspense>
          </ErrorBoundary>
        ),
        path: Report.path,
      },
    ],
    element: (
      <ReportsParams>
        <Reports />
      </ReportsParams>
    ),
    errorElement: <ErrorPage />,
    path: reportsPath,
  },
];

const stockExchangeRoutes: RouteObject[] = [
  {
    element: (
      <StockExchangeParams>
        <StockExchange />
      </StockExchangeParams>
    ),
    path: stockExchangePath,
  },
];

const yieldPredictionsRoutes: RouteObject[] = [
  {
    element: (
      <ErrorBoundary fallbackRender={({ error }) => <Failed error={error} />}>
        <Restoration key={yieldPredictionsPath} path={yieldPredictionsPath}>
          {(params) => (
            <Params params={params}>
              <YieldPredictions />
            </Params>
          )}
        </Restoration>
      </ErrorBoundary>
    ),
    path: yieldPredictionsPath,
  },
];

export { getReportsRoutes, stockExchangeRoutes, yieldPredictionsRoutes };
